import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { JWTService } from '../services/jwt.service';
import { environment } from 'src/environments/environment';
import { UserService } from '../services/user.service';

@Injectable()

/** The JwtInterceptor class intercepts HTTP requests and adds an authorization header with a JSON Web
Token if the user is logged in and the request is to the API URL. */
export class JwtInterceptor implements HttpInterceptor {
    constructor(private _auth: AuthService, private _user: UserService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
        // const loginStatus = this._auth.getLoginStatus();
        const jwt = this._user.getToken();
        // const isLoggedIn = loginStatus && jwt;
        const isApiUrl = request.url.startsWith(environment.apiUrl);
        if ((jwt != null) && isApiUrl) {
            request = request.clone({
                setHeaders: { Authorization: `Bearer ${jwt?.replace(/['"]+/g, '')}` }
            });
        }
        return next.handle(request);
    }
}
